import Segmented from 'components/new-ui/base/segmented/Segmented';

type Status = 'active' | 'archived';

type Props = {
    value: Status;
    onChange: (value: Status) => void;
};

const ArchivationStatusFilter = ({ value, onChange }: Props) => {
    return (
        <Segmented
            style={{ marginRight: 16 }}
            options={[
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'archived',
                    label: 'Archived',
                },
            ]}
            value={value}
            onChange={(value) => onChange(value as Status)}
        />
    );
};

export default ArchivationStatusFilter;
